import { render, staticRenderFns } from "./ComplainTypeListToolbar.vue?vue&type=template&id=12660c6c&"
import script from "./ComplainTypeListToolbar.vue?vue&type=script&lang=js&"
export * from "./ComplainTypeListToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports